// © Microsoft Corporation. All rights reserved.
import CopyrightForm from "./copyright-form/CopyrightForm";
import { FollowButton } from "./follow-button/FollowButton";
import GradientOverlay from "./common/gradient-overlay/GradientOverlay";
import Main from "./main/main";
import MultiLoginPage from "./multi-login-page/MultiLoginPage";
import NotificationCard from "./common/notification/NotificationCard";
import { NotificationTray } from "./common/notification/NotificationTray";
import OnboardingPage from "./onboarding-page/OnboardingPage";
import OnboardingThirdPartyPage from "./onboarding-page/OnboardingThirdPartyPage";
import OnboardingUnderagePage from "./onboarding-page/OnboardingUnderagePage";
import Popup from "./popup/Popup";
import ProfileManageDataPage from "./profile/profile-manage-data-page/ProfileManageDataPage";
import PublisherSubscribeFollowButton from "./publisher-subscribe-follow-button/PublisherSubscribeFollowButton";
import ReactionBreakdown from "./reaction-breakdown/ReactionBreakdown";
import ReactionBreakdownListItem from "./reaction-breakdown/ReactionBreakdownListItem";
import ReportMenu from "./common/report-menu/ReportMenu";

import {
    SocialExperienceRenderErrorCopyrightForm,
    SocialExperienceRenderErrorFollowButton,
    SocialExperienceRenderErrorGradientOverlay,
    SocialExperienceRenderErrorMain,
    SocialExperienceRenderErrorMultilineLogin,
    SocialExperienceRenderErrorNotificationCard,
    SocialExperienceRenderErrorNotificationTray,
    SocialExperienceRenderErrorOnbardingThirdParty,
    SocialExperienceRenderErrorOnboarding,
    SocialExperienceRenderErrorOnboardingUnderagePage,
    SocialExperienceRenderErrorPopup,
    SocialExperienceRenderErrorProfileManageDataPage,
    SocialExperienceRenderErrorPublisherSubscribeFollowButton,
    SocialExperienceRenderErrorReactionBreakdown,
    SocialExperienceRenderErrorReactionBreakdownListItem,
    SocialExperienceRenderErrorReportMenu,
    SocialExperienceRenderErrorUnknownComponent
} from "@msnews/diagnostics";

export const RenderErrors = {
    [CopyrightForm.name]: SocialExperienceRenderErrorCopyrightForm,
    [FollowButton.name]: SocialExperienceRenderErrorFollowButton,
    [GradientOverlay.name]: SocialExperienceRenderErrorGradientOverlay,
    [Main.name]: SocialExperienceRenderErrorMain,
    [MultiLoginPage.name]: SocialExperienceRenderErrorMultilineLogin,
    [NotificationCard.name]: SocialExperienceRenderErrorNotificationCard,
    [NotificationTray.name]: SocialExperienceRenderErrorNotificationTray,
    [OnboardingThirdPartyPage.name]: SocialExperienceRenderErrorOnbardingThirdParty,
    [OnboardingPage.name]: SocialExperienceRenderErrorOnboarding,
    [OnboardingUnderagePage.name]: SocialExperienceRenderErrorOnboardingUnderagePage,
    [Popup.name]: SocialExperienceRenderErrorPopup,
    [ProfileManageDataPage.name]: SocialExperienceRenderErrorProfileManageDataPage,
    [PublisherSubscribeFollowButton.name]: SocialExperienceRenderErrorPublisherSubscribeFollowButton,
    [ReactionBreakdown.name]: SocialExperienceRenderErrorReactionBreakdown,
    [ReactionBreakdownListItem.name]: SocialExperienceRenderErrorReactionBreakdownListItem,
    [ReportMenu.name]: SocialExperienceRenderErrorReportMenu,
    UnknownComponent: SocialExperienceRenderErrorUnknownComponent
};